import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-folderopen",
  "use": "icon-th-folderopen-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-folderopen\">\n<path d=\"M30.625 13.83C30.4394 13.5727 30.1952 13.3632 29.9127 13.2189C29.6301 13.0746 29.3173 12.9995 29 13H27V11C27 10.4696 26.7893 9.96086 26.4142 9.58579C26.0391 9.21071 25.5304 9 25 9H16.3337L12.8675 6.4C12.5207 6.14148 12.1 6.00125 11.6675 6H5C4.46957 6 3.96086 6.21071 3.58579 6.58579C3.21071 6.96086 3 7.46957 3 8V26C3 26.2652 3.10536 26.5196 3.29289 26.7071C3.48043 26.8946 3.73478 27 4 27H26.3875C26.5974 27 26.802 26.934 26.9722 26.8113C27.1425 26.6886 27.2699 26.5154 27.3363 26.3162L30.8975 15.6325C30.9976 15.3319 31.0252 15.0118 30.9778 14.6985C30.9304 14.3852 30.8095 14.0876 30.625 13.83ZM11.6675 8L15.1337 10.6C15.4804 10.8587 15.9012 10.9989 16.3337 11H25V13H8.72125C8.30147 13 7.89232 13.132 7.55176 13.3775C7.2112 13.6229 6.95651 13.9693 6.82375 14.3675L5 19.8375V8H11.6675ZM25.6675 25H5.3875L8.72125 15H29L25.6675 25Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-folderopen.svg
// module id = bQZi
// module chunks = 84